module.exports = __webpack_public_path__ + "img/other phones@2x.b814194d.png";